let shouldShowAgeRangeResetConfirmation = false;

export const markAgeRangeResetConfirmation = () => {
  shouldShowAgeRangeResetConfirmation = true;
};

export const consumeAgeRangeResetConfirmation = () => {
  const shouldShowConfirmation = shouldShowAgeRangeResetConfirmation;
  shouldShowAgeRangeResetConfirmation = false;
  return shouldShowConfirmation;
};
